import { render, staticRenderFns } from "./BlackBooks.vue?vue&type=template&id=1c7356d4&scoped=true&"
import script from "./BlackBooks.vue?vue&type=script&lang=js&"
export * from "./BlackBooks.vue?vue&type=script&lang=js&"
import style0 from "./BlackBooks.vue?vue&type=style&index=0&id=1c7356d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7356d4",
  null
  
)

export default component.exports